import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'shared-ui/lib/components/Button';
import { TableColumn } from 'shared-ui/lib/customs/react/generic-table/TableColumn';
import { UserLevelCell } from '../components/UserLevelCell';
import { useCan, UserLevel } from '../hooks/use-can';
import { TeamIndexSceneQuery } from '../generated/graphql';

const name: TableColumn = {
  field: 'name',
  text: 'User:name',
};

const email: TableColumn = {
  field: 'email',
  text: 'User:email',
};

const levelAction = (
  onUpdate: (opt: { variables: { body: { userId: string; level: string } } }) => void
): TableColumn => ({
  field: 'level',
  text: 'User:level',
  formatter: (data: TeamIndexSceneQuery['users']['list'][0]) => (
    <UserLevelCell user={data} onUpdate={onUpdate} />
  ),
});

const deleteAction = (onDelete: (opt: { variables: { id: string } }) => void): TableColumn => ({
  field: 'id',
  text: 'General:delete',
  formatter: (data: TeamIndexSceneQuery['users']['list'][0]) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { t } = useTranslation();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { canManageUsers } = useCan();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const handleDelete = useCallback(
      (id: string) => {
        if (confirm(t('TeamIndexScene:deletePrompt'))) onDelete({ variables: { id } });
      },
      [t]
    );

    const isMasterRow = data.isPartnerAccountOwner || data.level === UserLevel.MASTER;
    if (isMasterRow || !canManageUsers) return <span />;

    return (
      <Button type="button" onClick={() => handleDelete(data.id)}>
        {t('General:delete')}
      </Button>
    );
  },
});

export const userColumns = {
  name,
  deleteAction,
  levelAction,
  email,
};
